module.exports = __webpack_public_path__ + "static/img/pic-cnt-2.25a466c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-2.png
// module id = +4cV
// module chunks = 0